import React, { ReactElement } from "react";
import Content from "./Content";

export default function Sup(props: any): ReactElement {
  const { children, align, type } = props;

  return (
    <sup style={{ ...(align && { textAlign: align }), marginBottom: "10px" }}>
      {" "}
      <Content contentValue={children} />
    </sup>
  );
}
